import {
    Article as ArticleIcon,
    LocalOffer as LocalOfferIcon,
    School as SchoolIcon,
    ShoppingCart as ShoppingCartIcon,
    TrendingUp as TrendingUpIcon,
  } from '@mui/icons-material';
  import { Autocomplete, Chip, FormControl, ListItem, ListItemText, TextField, Typography } from '@mui/material';
  import { useTranslation } from 'react-i18next';
  
  const ContentFocusSelector = ({ value, onChange, focusOptions }) => {
    const { t: translate } = useTranslation();
  
    const iconMap = {
      article: <ArticleIcon />,
      education: <SchoolIcon />,
      trending: <TrendingUpIcon />,
      shopping: <ShoppingCartIcon />,
      promotions: <LocalOfferIcon />,
    };
  
    return (
      <FormControl fullWidth sx={{ mb: 3 }}>
        <Autocomplete
          multiple
          options={focusOptions}
          getOptionLabel={(option) => option.label}
          value={value}
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          disableCloseOnSelect
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={option.value}
                label={option.label}
                avatar={iconMap[option.iconKey]}
              />
            ))
          }
          renderOption={(props, option, { selected }) => (
            <ListItem
              {...props}
              sx={{
                backgroundColor: selected ? 'rgba(0, 0, 0, 0.04)' : 'inherit',
                fontWeight: selected ? 'bold' : 'normal',
              }}
            >
              {iconMap[option.iconKey]}
              <ListItemText
                sx={{
                  ml: 1,
                  '& .MuiListItemText-primary': {
                    fontWeight: selected ? 'bold' : 'normal',
                  },
                }}
                primary={option.label}
              />
            </ListItem>
          )}
          renderInput={(params) => (
            <TextField {...params} placeholder={value.length === 0 ? translate('auto_post.select_content_placeholder', 'Select content you want to create') : ''} />
          )}
        />
      </FormControl>
    );
  };
  
  export default ContentFocusSelector;